// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2HjZ0","form":"styles_form__2-f38"};